import { Button, Card, Cell, Form, Popup, Toast } from 'react-vant';
import { FC, useEffect } from 'react';
import styles from './index.less'
import { confirmationTicketFee } from '@/service/repaire';

interface BindFeeProps {
  visible: boolean;
  close: (value?: boolean) => void;
  recordFeeList: Array<any>;
  paidAmount?: string,
  sequenceNbr?: string
}
const BindFee: FC<BindFeeProps> = (props) => {
  const { visible, close, recordFeeList, paidAmount, sequenceNbr } = props;
  console.log('sequenceNbr>>>', sequenceNbr)
  const [form] = Form.useForm();

  const onFinish = () => {
    confirmationTicketFee(sequenceNbr).then((res) => {
      if (res && res.code === 200) {
        Toast.success('费用确认成功！！');

        close(true);
      }
    });
  };

  useEffect(() => {
    if (!visible) {
      form.resetFields();
    }
  }, [visible]);

  return (
    <Popup
      position={'bottom'}
      style={{ height: '90%' }}
      visible={visible}
      onClose={close}
      closeable
      round
      title={'有偿信息'}
    >
      <div className={styles.contanier}>
      <>
          {recordFeeList.map((field, idx) => (
            <Card className={styles.bg} key={idx}>
              <Card.Body>
                <Cell.Group key={idx}>
                  <Cell title="收费项类型" value={field.itemCategoryName || ''} />
                  <Cell title="收费项名称" value={field.feeItemName || ''} />
                  <Cell title="标准单价" value={field.price || ''} />
                  <Cell title="标准工时" value={field.usageOrHours || ''} />
                  <Cell title="费用" value={field.totalAmount || ''} />
                </Cell.Group>
              </Card.Body>
            </Card>
          ))}
        </>

        <Card className={styles.bg}>
          <Card.Body>
            <Cell.Group>
              <Cell title="总费用" value={paidAmount || ''} />
            </Cell.Group>
          </Card.Body>
        </Card>
      </div>
      
      <div className={styles['buttons']}>
          <Button type="primary" block round  onClick={onFinish} >确认有偿服务</Button>
      </div>
     
    </Popup>
  );
};

export default BindFee;
